import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "light", // switch to "dark" anytime

    primary: {
      main: "#e60000ff",      // Vodafone red
      light: "#ff4d4d",
      dark: "#a30000",
      contrastText: "#ffffff",
    },

    secondary: {
      main: "#ff9800",      // orange accent
      light: "#ffc947",
      dark: "#c66900",
      contrastText: "#ffffff",
    },

    background: {
      default: "#fff7f7",   // very light warm background
      paper: "#ffffff",     // white cards
    },

    success: {
      main: "#2e7d32",
    },

    error: {
      main: "#d32f2f",
    },

    info: {
      main: "#0288d1",
    },

    warning: {
      main: "#ed6c02",
    },
  },

  typography: {
    fontFamily: "'Roboto', 'Open Sans', sans-serif",
    h1: { fontWeight: 600 },
    h2: { fontWeight: 500 },
    h3: { fontWeight: 500 },
    button: {
      textTransform: "none", // disables ALL CAPS buttons
      fontWeight: 600,
    },
  },

  shape: {
    borderRadius: 12,
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: "10px 20px",
          boxShadow: "none",
          ":hover": {
            boxShadow: "0 3px 6px rgba(0,0,0,0.1)",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 16,
        },
      },
    },
  },
});

export default theme;

